import INSTITUTION_TYPES from './types';
import {
	type IInstitution,
	type IInstitutionCourse,
	type IMetadata,
} from 'src/models';

function initialState() {
	return {
		type: INSTITUTION_TYPES.INITIAL_STATE,
	};
}

function getAll(page?: number, pageSize?: number) {
	return {
		type: INSTITUTION_TYPES.GET_ALL,
		payload: { page, pageSize },
	};
}

function setAll(data: IInstitution[], metadata?: IMetadata) {
	return {
		type: INSTITUTION_TYPES.SET_ALL,
		payload: { data, metadata },
	};
}

function getOne(id: number) {
	return {
		type: INSTITUTION_TYPES.GET_ONE,
		payload: { id },
	};
}

function setOne(institution: IInstitution) {
	return {
		type: INSTITUTION_TYPES.SET_ONE,
		payload: { institution },
	};
}

function create(institution: IInstitution) {
	return {
		type: INSTITUTION_TYPES.CREATE,
		payload: { institution },
	};
}

function update(institution: IInstitution) {
	return {
		type: INSTITUTION_TYPES.UPDATE,
		payload: { institution },
	};
}

function remove(id: number) {
	return {
		type: INSTITUTION_TYPES.REMOVE,
		payload: { id },
	};
}

function assignCourses(
	institutionId: number,
	institutionCourses: IInstitutionCourse[],
) {
	return {
		type: INSTITUTION_TYPES.ASSIGN_COURSES,
		payload: { institutionId, institutionCourses },
	};
}

const clientActions = {
	initialState,
	getAll,
	setAll,
	getOne,
	setOne,
	create,
	update,
	remove,
	assignCourses,
};

export default clientActions;
